import { iconCloseSmall } from '@tesla/design-system-icons';
import React from 'react';
import { Icon } from '../icon/icon.js';
/**
 * A formatted list item with a remove button that allows a file to be removed from a file input
 * If the browser supports the DataTransfer constructor, it allows us to remove files. CanRemove
 * is a boolean value set inside form-item-files-list based on Data Transfer constructor support
 */
export const FileListItem = ({ canRemove = true, name, onRemove }) => {
    return (React.createElement("li", { className: "tds-list-item--file" },
        React.createElement("span", null, name),
        canRemove && (React.createElement("button", { "data-name": name, onClick: onRemove, type: "button" },
            React.createElement(Icon, { data: iconCloseSmall, inline: true })))));
};
